var _rect, _path, _path2, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4772_52692)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4772_52692)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.333L16.5 18.6663C16.5 18.6663 16.5 23.9997 16.5 26.6663C16.5 37.1063 25.0853 41.981 28.5 42.6663C31.9147 41.981 40.5 37.1063 40.5 26.6663C40.5 23.9997 40.5 18.6663 40.5 18.6663L28.5 13.333Z",
    fill: "url(#paint0_linear_4772_52692)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4772_52692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 13,
    width: 25,
    height: 30
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.333L16.5 18.6663C16.5 18.6663 16.5 23.9997 16.5 26.6663C16.5 37.1063 25.0853 41.981 28.5 42.6663C31.9147 41.981 40.5 37.1063 40.5 26.6663C40.5 23.9997 40.5 18.6663 40.5 18.6663L28.5 13.333Z",
    fill: "#F49120"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4772_52692)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 27.9995,
    y: 7,
    width: 18,
    height: 47,
    fill: "white"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#E0E5EC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4772_52692",
    x1: 16.5,
    y1: 7.5,
    x2: 40.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA945"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4772_52692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(12.5 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4772_52692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 62,
    fill: "white",
    transform: "translate(16.5 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldRound);
export default __webpack_public_path__ + "static/media/shield-round.a3f99b815b2b660c07a8c1f350ec9bb1.svg";
export { ForwardRef as ReactComponent };